import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

// Redux
import { withRouter, Link, useHistory } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { Modal, ModalBody } from "reactstrap"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import SweetAlert from "react-bootstrap-sweetalert"
//Social Media Imports
import { GoogleLogin } from "react-google-login"
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"

// actions
import { loginUser, socialLogin } from "../../store/actions"
import toastr from "toastr"
// import images
import logo from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"

//Import config
import { facebook, google } from "../../config"
import axios from "../../axios"
import numeral from "numeral"

const Login = props => {
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const dispatch = useDispatch()
  const [Compnayid, setCompnayid] = useState("")
  const [CompanyCollection, setCompanyCollection] = useState([])
  const [FInalyear, setFInalyear] = useState("2022-2023")
  const [potodaycollection, setpotodaycollection] = useState([])
  const [sotodaycollection, setsotodaycollection] = useState([])
  const [pomonthcollection, setpomonthcollection] = useState([])
  const [somonthcollection, setsomonthcollection] = useState([])
  const [purchaseinvoicecollections, setpurchaseinvoicecollections] = useState(
    []
  )
  const [salesinvoicecollections, setsalesinvoicecollections] = useState([])
  const history = useHistory()
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      User_Code: "" || "",
      Password: "" || "",
    },
    validationSchema: Yup.object({
      User_Code: Yup.string().required("Please Enter Your User Code"),
      Password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async values => {
      //dispatch(loginUser(values, props.history));
      const Login1 = await axios.instance
        .post(
          "/Login",
          {
            User_Code: values.User_Code,
            Password: values.Password,
          },
          {
            headers: {
              Authorization: tokent,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async res => {
          localStorage.setItem("authtoken", "Bearer " + res.data.token)

          if (res.data.getlogin.length === 1) {
            for (const data of res.data.getlogin) {
              localStorage.setItem("UserCode", data.User_Code)
              localStorage.setItem("UserName", data.User_Name)

              localStorage.setItem("UserId", data.User_Id)

              history.push("/subcategory")
            }
          } else {
            setInvalieusernameandpassword(true)
          }
        })

      ////////console.log(values)
    },
  })

  const data = () => {
    history.push("/subcategory")
  }

  useEffect(() => {
    const firstday = new Date().getFullYear() - 1
    const secondday = new Date().getFullYear()

    const Finalyear = firstday.toString() + "-" + secondday.toString()
    ////////console.log(Finalyear)
    localStorage.setItem("FInalyear", FInalyear)
    // setFInalyear(Finalyear)
    document.body.className = "authentication-bg"
    // remove classname when component will unmount

    // return function cleanup() {
    //   document.body.className = "";
    // };
  }, [])

  const [Invalieusernameandpassword, setInvalieusernameandpassword] =
    useState(false)
  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              {/* <div className="text-center">
                <Link to="/" className="mb-5 d-block auth-logo">
                  <img src={logo} alt="" height="22" className="logo logo-dark" />
                  <img src={logolight} alt="" height="22" className="logo logo-light" />
                </Link>
              </div> */}
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-2">
                  <div className="text-center ">
                    <h5 className="text-primary">Welcome Back !</h5>
                    <p className="text-primary mt-1">
                      <b>Sign in to continue to Target.</b>
                    </p>
                  </div>
                  <div className="p-2 ">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {/* {error ? <Alert color="danger">{error}</Alert> : null} */}

                      <div className="mb-3">
                        <Label className="form-label">User Code</Label>
                        <Input
                          name="User_Code"
                          className="form-control"
                          placeholder="Enter User Code"
                          type="text"
                          autoComplete="off"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.User_Code || ""}
                          invalid={
                            validation.touched.User_Code &&
                            validation.errors.User_Code
                              ? true
                              : false
                          }
                        />
                        {validation.touched.User_Code &&
                        validation.errors.User_Code ? (
                          <FormFeedback type="invalid">
                            {validation.errors.User_Code}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        {/* <div className="float-end">
                          <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                        </div> */}
                        <Label className="form-label">Password</Label>
                        <Input
                          name="Password"
                          value={validation.values.Password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.Password &&
                            validation.errors.Password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.Password &&
                        validation.errors.Password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.Password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3">
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        {/* <h5 className="font-size-14 mb-3">Sign in with</h5>

                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <FacebookLogin
                              appId={facebook.APP_ID}
                              autoLoad={false}
                              callback={facebookResponse}
                              render={renderProps => (
                                <Link
                                to="#"
                                  className="social-list-item bg-primary text-white border-primary"
                                  onClick={renderProps.onClick}
                                >
                                  <i className="mdi mdi-facebook" />
                                </Link>
                              )}
                            />
                          </li>
                          {google.CLIENT_ID != '' &&
                          <li className="list-inline-item">
                            <GoogleLogin
                              clientId={google.CLIENT_ID}
                              render={renderProps => (
                                <Link
                                to="#"
                                  className="social-list-item bg-danger text-white border-danger"
                                  onClick={renderProps.onClick}
                                >
                                  <i className="mdi mdi-google" />
                                </Link>
                              )}
                              onSuccess={googleResponse}
                              onFailure={() => {}}
                            />
                          </li>
                          }
                        </ul> */}
                      </div>

                      {/* <div className="mt-4 text-center">
                        <p className="mb-0">Don&apos;t have an account ? <a href="/register" className="fw-medium text-primary"> Signup now </a> </p>
                      </div> */}
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {Invalieusernameandpassword ? (
          <SweetAlert
            title="Invalid User Code and Password"
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            danger
            onConfirm={() => {
              setInvalieusernameandpassword(false)
            }}
          >
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-info btn-lg ms-2"
                onClick={() => setInvalieusernameandpassword(false)}
              >
                Close
              </button>
            </div>
          </SweetAlert>
        ) : null}
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
